import { orderBy } from 'lodash';

const orderResidenceByOpeningDate = (pagesResidences) => {
  const residencesCollection = pagesResidences
    .map((residenceData) => {
      const residence = residenceData?.data?.residence?.data || {};
      return {
        ...residence,
        slug: residenceData?.data?.slug,
      };
    })
    .reduce((acc, residencePage) => {
      const { openingDate } = residencePage;
      const openingJSDate = new Date(openingDate);
      const today = new Date();
      const sixMonthsFromNow = new Date().setMonth(today.getMonth() + 6);

      if (openingJSDate > today && openingJSDate < sixMonthsFromNow) {
        return {
          ...acc,
          inf6: orderBy([...acc.inf6, residencePage], ['openingDate', 'nameShort']),
        };
      }
      if (openingJSDate >= sixMonthsFromNow) {
        return {
          ...acc,
          sup6: orderBy([...acc.sup6, residencePage], ['openingDate', 'nameShort']),
        };
      }

      return {
        ...acc,
        past: orderBy([...acc.past, residencePage], 'nameShort'),
      };
    }, { inf6: [], sup6: [], past: [] });

  return [].concat(residencesCollection.inf6, residencesCollection.sup6, residencesCollection.past);
};

export default orderResidenceByOpeningDate;
